import { useEffect } from 'react';

import { useMaplibreMap } from '@App/components/MaplibreMap/maplibre-map.context';
import { removeLayerAndSource } from '@App/components/MaplibreMap/maplibre-map.utils';
import { useMeasurementStations } from '@services/query.service';

const SOURCE_ID = 'measurement-stations';
const LAYER_ID = 'measurement-stations-points';
const ICON_ID = 'measurement-station-pin';

function MeasurementStationsLayer() {
  const { map, isLoading } = useMaplibreMap();
  const { data: measurementStations } = useMeasurementStations();

  useEffect(() => {
    if (!map || isLoading) {
      return undefined;
    }

    map.addSource(SOURCE_ID, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: [],
      },
    });

    map.addLayer({
      id: LAYER_ID,
      type: 'symbol',
      source: SOURCE_ID,
      layout: {
        'icon-image': ICON_ID,
        'icon-anchor': 'bottom',
        'icon-size': 1,
        'icon-allow-overlap': true,
      },
    }, 'z-index-5');

    return () => {
      removeLayerAndSource(map, LAYER_ID, SOURCE_ID);
    };
  }, [isLoading, map]);

  useEffect(() => {
    if (isLoading || !measurementStations || !map.getSource(SOURCE_ID)) {
      return;
    }

    map.getSource(SOURCE_ID).setData({
      type: 'FeatureCollection',
      features: measurementStations,
    });
  }, [isLoading, measurementStations, map]);

  return null;
}

export default MeasurementStationsLayer;
